import { useTranslation } from "react-i18next";
import BaseContainer from "../../ui/BaseContainer/BaseContainer";
import classes from "./Intro.module.scss";
import { ReactComponent as LavinaDownIcon } from "@assets/images/lavina-button--down.svg";
import PhonePhotoUrl from "@assets/images/main/intro_phone.png";
import { AnimationOnScroll } from "react-animation-on-scroll";

const Intro = () => {
  const { t } = useTranslation();

  return (
    <AnimationOnScroll animateIn="animate__fadeIn" animateOnce>
      <BaseContainer className={classes.intro}>
        <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce delay={150}>
          <h1>{t("intro.title")}</h1>
        </AnimationOnScroll>
        <div className={classes["intro-description"]}>
          <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce delay={150}>
            <p>{t("intro.subtitle")}</p>
          </AnimationOnScroll>
          <div className={classes["intro__image-wrapper"]}>
            <AnimationOnScroll animateIn="animate__zoomIn" animateOnce delay={250}>
              <div className={classes["intro__icon-wrapper"]}>
                <LavinaDownIcon className={classes["intro__icon"]} />
              </div>
              <img className={classes["intro__image"]} src={PhonePhotoUrl} alt="" />
            </AnimationOnScroll>
          </div>
        </div>
      </BaseContainer>
    </AnimationOnScroll>
  );
};

export default Intro;
